const legal = {
  infoPageLayout: {
    manageCookies: "Meine Cookies verwalten",
  },
  terms: {
    title: "Nutzungsbedingungen",
    subtitle: "Allgemeine Regeln für den Zugang zu und die Nutzung von Qubiq.",
    sections: [
      {
        title: "1. Zweck",
        body: "{{brandName}} ist eine interaktive Video-Streaming-Plattform, auf der Inhalte angesehen, integrierte Spiele genutzt und Community-Funktionen verwendet werden können.",
      },
      {
        title: "2. Zugang zum Dienst",
        body: "Der Zugang zu bestimmten Qubiq-Funktionen erfordert die Erstellung eines Kontos. Nutzer verpflichten sich, korrekte Angaben zu machen, ihre Zugangsdaten vertraulich zu behandeln und den Dienst nicht zweckwidrig zu nutzen.",
      },
      {
        title: "3. Verbotene Inhalte und Verhaltensweisen",
        body: "Es ist verboten, rechtswidrige, betrügerische, hasserfüllte, gewalttätige, irreführende, nicht autorisierte pornografische Inhalte, Inhalte, die Rechte Dritter verletzen, oder Inhalte entgegen den Moderationsregeln von Qubiq zu veröffentlichen, zu verbreiten oder weiterzuleiten.",
      },
      {
        title: "4. Geistiges Eigentum",
        body: "Die Elemente der Qubiq-Plattform, ihr Design, ihre Marken, visuellen Inhalte, Oberflächen und Entwicklungen bleiben geschützt. Ohne ausdrückliche Genehmigung dürfen sie nicht kopiert, reproduziert, extrahiert oder zu kommerziellen Zwecken wiederverwendet werden.",
      },
      {
        title: "5. Sperrung oder Löschung des Kontos",
        body: "Qubiq kann den Zugang zum gesamten oder zu Teilen des Dienstes einschränken, sperren oder entfernen, wenn gegen diese Bedingungen verstoßen wird, Betrugsversuche vorliegen, schädliches Verhalten gegenüber der Community gezeigt wird oder ein Sicherheitsrisiko besteht.",
      },
      {
        title: "6. Kontakt",
        body: "Bei Fragen zu diesen Bedingungen kannst du an {{contactEmail}} schreiben.",
      },
    ],
  },
  privacy: {
    title: "Datenschutzerklärung",
    subtitle: "Wie Qubiq personenbezogene Daten verarbeitet und wie du deine Rechte ausüben kannst.",
    sections: [
      {
        title: "Verantwortlicher",
        body: "{{companyName}}, erreichbar unter {{websiteUrl}}, handelt als Verantwortlicher für die im Rahmen der Plattform {{brandName}} verarbeiteten Daten.",
      },
      {
        title: "Verarbeitete Daten",
        body: "Je nach Nutzung des Dienstes können wir folgende Daten verarbeiten: Kontodaten, E-Mail, Benutzername, Profilbild, Nutzungshistorie, Community-Interaktionen, Einwilligungspräferenzen, technische Browserinformationen sowie Daten zu Wallet oder Gewinnen, wenn diese Funktionen genutzt werden.",
      },
      {
        title: "Zwecke und Rechtsgrundlagen",
        body: "- Bereitstellung des Dienstes, Videowiedergabe, Spiele, Profil und Benachrichtigungen: Vertragserfüllung.\n- Absicherung der Plattform, Betrugsbekämpfung und Moderation von Inhalten: berechtigtes Interesse und gesetzliche Pflichten.\n- Bearbeitung von Supportanfragen und DSGVO-Rechten: gesetzliche Pflicht und berechtigtes Interesse.\n- Reichweitenmessung mit Google Analytics: Einwilligung.",
      },
      {
        title: "Empfänger",
        body: "Die Daten sind je nach Bedarf für berechtigte Qubiq-Teams und technische Dienstleister zugänglich. Qubiq verwendet insbesondere Clerk für die Authentifizierung und Google Analytics für die Reichweitenmessung, wenn du zustimmst.",
      },
      {
        title: "Speicherdauer",
        body: "Die Speicherdauer variiert je nach Zweck:\n- Benutzerkonto: für die Dauer des Kontos und danach entsprechend den geltenden gesetzlichen Pflichten;\n- technische und Sicherheitsprotokolle: für die begrenzte Zeit, die für Sicherheit und Diagnose erforderlich ist;\n- Cookie-Einstellungen: 6 Monate;\n- Reichweitendaten: entsprechend der Google-Analytics-Konfiguration und der von Qubiq gewählten Aufbewahrungsrichtlinie.",
      },
      {
        title: "Übermittlungen außerhalb der EU",
        body: "Einige Dienstleister können Daten außerhalb der Europäischen Union verarbeiten. In diesem Fall setzt Qubiq die vom DSGVO geforderten geeigneten Garantien um, insbesondere angemessene Vertragsklauseln, wenn diese erforderlich sind.",
      },
      {
        title: "Deine Rechte",
        body: "Je nach Fall hast du das Recht auf Auskunft, Berichtigung, Löschung, Widerspruch, Einschränkung, Datenübertragbarkeit und das Recht, eine Einwilligung jederzeit für darauf gestützte Verarbeitungen zu widerrufen. Du kannst außerdem eine Beschwerde bei der CNIL einreichen.",
      },
      {
        title: "Kontakt zu personenbezogenen Daten",
        body: "Für jede Anfrage zu deinen personenbezogenen Daten: {{privacyEmail}}.",
      },
    ],
  },
  legalNotice: {
    title: "Impressum",
    subtitle: "Informationen über den Herausgeber des Dienstes und das Hosting der Website.",
    items: {
      editorLabel: "Herausgeber der Website",
      legalFormLabel: "Rechtsform",
      legalFormValue: "{{legalForm}} — Stammkapital: {{capital}}",
      registrationLabel: "Eintragung",
      registrationValue: "Handels- und Gesellschaftsregister {{registrationCity}} {{registrationNumber}}",
      registrationDateLabel: "Eintragungsdatum",
      euidLabel: "EUID",
      vatLabel: "Umsatzsteuer-Identifikationsnummer",
      addressLabel: "Adresse",
      activitiesLabel: "Haupttätigkeiten",
      publicationDirectorLabel: "Verantwortlich für die Veröffentlichung",
      contactLabel: "Kontakt",
      hostingLabel: "Hosting",
      hostingValue: "{{hostingCompany}}\n{{hostingAddress}}",
      intellectualPropertyLabel: "Geistiges Eigentum",
      intellectualPropertyValue:
        "Die Inhalte, Oberflächen, Marken, visuellen Elemente und Entwicklungen des Qubiq-Dienstes sind geschützt. Jede unbefugte Vervielfältigung oder Nutzung ist untersagt.",
    },
  },
  cookies: {
    title: "Cookie-Richtlinie",
    subtitle: "Informationen über die von Qubiq verwendeten Tracker und die Verwaltung deiner Auswahl.",
    sections: [
      {
        title: "Grundsatz",
        body: "Qubiq verwendet Cookies und andere Tracker, die für den Betrieb des Dienstes erforderlich sind. Reichweiten-Tracker sind standardmäßig deaktiviert und werden erst nach deiner ausdrücklichen Zustimmung aktiviert.",
      },
      {
        title: "Verwendete Kategorien",
        body: "- Notwendige Cookies: Sicherheit, Anmeldung, Sitzungsstabilität, wesentlicher Betrieb.\n- Reichweitenmessung: Google Analytics 4, mit Einwilligung.\n- Marketing: derzeit auf Qubiq nicht aktiviert.",
      },
      {
        title: "Dauer und Dritte",
        body: "- Qubiq-Einwilligungspräferenz: lokal unter dem Schlüssel {{consentStorageKey}} für 6 Monate gespeichert.\n- {{analyticsProvider}}: Cookies zur Reichweitenmessung, von Google angegebene Standarddauer: bis zu 2 Jahre, vorbehaltlich Browserbeschränkungen und der von Qubiq gewählten Konfiguration.\n- Drittanbieter für die Reichweitenmessung: Google.",
      },
      {
        title: "Google Analytics",
        body: "{{analyticsProvider}} wird vor deiner Einwilligung nicht geladen. Wenn du zustimmst, nutzt Qubiq die Reichweitenmessung, um die Nutzung des Dienstes besser zu verstehen, die Leistung zu verbessern und große Navigationstrends zu erkennen.",
      },
      {
        title: "Einwilligung widerrufen oder ändern",
        body: "Du kannst deine Auswahl jederzeit über die Schaltfläche „Meine Cookies verwalten“ auf dieser Seite, in den Informationslinks der Website und im Profilmenü ändern.",
      },
      {
        title: "Regulatorischer Hinweis",
        body: "Auf Qubiq ist das Ablehnen von Reichweiten-Cookies genauso einfach wie das Akzeptieren. Der Hauptdienst bleibt auch ohne Aktivierung von Google Analytics zugänglich.",
      },
    ],
  },
  moderation: {
    title: "Qubiq-Moderationsregeln",
    subtitle: "Die Regeln der Qubiq Republic zum Schutz der Community, der Creator und der Spieler.",
    sections: [
      {
        title: "1. Respekt gegenüber der Community",
        body: "Beleidigungen, gezielte Angriffe, Demütigungen, Drohungen, Belästigungskampagnen oder Verhaltensweisen, die darauf abzielen, anderen Nutzern, Creatorn oder Moderatoren zu schaden, sind nicht erlaubt.",
      },
      {
        title: "2. Illegale oder gefährliche Inhalte",
        body: "Verboten sind: Verherrlichung von Verbrechen, Terrorismus, kinderpornografische Inhalte, Doxxing, unbefugte Verbreitung personenbezogener Daten, Betrug, Hacking, Hassrede oder jede Veröffentlichung, die gegen das Gesetz verstößt.",
      },
      {
        title: "3. Täuschung, Spam und Manipulation",
        body: "Es ist verboten zu spammen, Reichweiten künstlich zu manipulieren, falsche Gewinnspiele zu veröffentlichen oder Nutzer über Gewinne, Spiele, Qubs oder Teilnahmebedingungen zu täuschen.",
      },
      {
        title: "4. Schutz Minderjähriger",
        body: "Sexualisierte, schockierende, demütigende oder für Minderjährige gefährliche Inhalte sind verboten. Nutzer müssen jede unangemessene Inszenierung oder Ausnutzung schutzbedürftiger Zielgruppen vermeiden.",
      },
      {
        title: "5. Spiele und Fair Play",
        body: "Jeder Versuch zu cheaten, missbräuchlich zu automatisieren, Run-Regeln zu umgehen, Belohnungen zu duplizieren, Bugs auszunutzen oder das Spielerlebnis absichtlich zu beeinträchtigen, kann zur Sperrung oder Löschung des Kontos führen.",
      },
      {
        title: "6. Rechte Dritter",
        body: "Du musst über die notwendigen Rechte verfügen, um Inhalte auf Qubiq zu veröffentlichen. Verstöße gegen Urheberrechte, Bildrechte, Privatsphäre oder Marken Dritter können zu sofortiger Moderation führen.",
      },
      {
        title: "7. Mögliche Maßnahmen",
        body: "Qubiq kann Inhalte entfernen, bestimmte Funktionen einschränken, das Teilen blockieren, ein Konto sperren, plattformbezogene Vorteile entziehen oder Sachverhalte den Behörden melden, wenn die Situation dies rechtfertigt.",
      },
      {
        title: "8. Qubiq-Geist",
        body: "Qubiq ist eine interaktive Plattform: Man kann diskutieren, spielen, performen und teilen. Das Erlebnis muss jedoch gesund, fair, verständlich und respektvoll bleiben. Wenn Inhalte dieses Gleichgewicht stören, können sie moderiert werden.",
      },
    ],
  },
};

export default legal;
